import { render, staticRenderFns } from "./BulkTime.vue?vue&type=template&id=140c7396&scoped=true&"
import script from "./BulkTime.vue?vue&type=script&lang=js&"
export * from "./BulkTime.vue?vue&type=script&lang=js&"
import style0 from "./BulkTime.vue?vue&type=style&index=0&id=140c7396&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140c7396",
  null
  
)

export default component.exports